import api from 'api';

export const authenticate = api('POST /api/auth/authenticate');
export const logout = api('POST /api/auth/logout');
export const isAuthenticated = api('GET /api/auth/legacy-is-authenticated');
